import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmbeddedNaptarPage } from './embedded-naptar.page';

const routes: Routes = [
  {
    path: '',
    component: EmbeddedNaptarPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmbeddedNaptarPageRoutingModule {}
